import {Injectable} from '@angular/core';
import {
  DelegoRapidPayThreeDSecureInfoWithDelegoToken
} from '../../../../model/delego-rapidpay/delego-rapidpay-authenticate';
import {AmexDelegoAuthenticationValidationService} from './amex-delego-authentication-validation.service';
import {DefaultDelegoAuthenticationValidationService} from './default-delego-authentication-validation.service';
import {
  DelegoAuthenticationValidation,
  DelegoAuthenticationValidations
} from '@app/payment/services/delego-rapidpay/validation/delego-athentication-validations.model';


@Injectable({
  providedIn: 'root'
})
export class DelegoAuthenticationValidationService {

  private delegoAuthenticationValidationStrategyService: DelegoAuthenticationValidations = {
    amex: this.amexDelegoAuthenticationValidation,
    default: this.defaultDelegoAuthenticationValidation
  };

  constructor(private amexDelegoAuthenticationValidation: AmexDelegoAuthenticationValidationService,
              private defaultDelegoAuthenticationValidation: DefaultDelegoAuthenticationValidationService) {
  }

  isAuthenticationValid(authResponse: DelegoRapidPayThreeDSecureInfoWithDelegoToken, cardType: string): boolean {
    return this.getAuthenticationValidationStrategy(cardType).isValid(authResponse);
  }

  private getAuthenticationValidationStrategy(cardType: string): DelegoAuthenticationValidation {
    return this.delegoAuthenticationValidationStrategyService[cardType?.toLowerCase()] || this.delegoAuthenticationValidationStrategyService.default;
  }
}
